module.exports = {
  title: `Created for Crisis`,
  titleTemplate: "%s | Created for Crisis",
  description: `Created For Crisis is an international design and research team with a focus on humanitarian and public health needs.`,
  author: `Created for Crisis`,
  siteUrl: "https://createdforcrisis.org",
  image: "/SEOImage.png",
  twitter: "@Created4Crisis",
  facebook: "createdforcrisis",
  siteLanguage: "en", // Language Tag on <html> element
  ogLanguage: "en_US", // Facebook Language

  // JSONLD / Manifest
  favicon: "src/assets/favicons/CfC-Favicon-64.png", // Used for manifest favicon generation
  shortName: "CFC Website", // shortname for manifest. MUST be shorter than 12 characters
  themeColor: "#10375C",
  backgroundColor: "#FFFFFF",
}
